import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let EFileMappingType;
(function (EFileMappingType) {
  EFileMappingType["Appointment"] = "appointment";
  EFileMappingType["AppointmentNoSync"] = "appointment-no-sync";
  EFileMappingType["Availability"] = "availability";
  EFileMappingType["Patient"] = "patient";
  EFileMappingType["Referral"] = "referral";
  EFileMappingType["Recall"] = "recall";
  EFileMappingType["Waitlist"] = "waitlist";
})(EFileMappingType || (EFileMappingType = {}));
export const fieldsFileMapping = {
  createdAt: {
    type: 'Date'
  },
  deleted: {
    type: 'Number'
  },
  integrator: {
    type: 'Option',
    values: EExternalSource
  },
  mapping: {
    type: 'Unknown'
  },
  sftp: {
    type: 'Boolean'
  },
  type: {
    type: 'Option',
    values: EFileMappingType
  },
  updatedAt: {
    type: 'Date'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  }
};